import { render, staticRenderFns } from "./InstagramBusinessChannelDemographics.vue?vue&type=template&id=3a3d1ec2"
import script from "./InstagramBusinessChannelDemographics.vue?vue&type=script&lang=js"
export * from "./InstagramBusinessChannelDemographics.vue?vue&type=script&lang=js"
import style0 from "./InstagramBusinessChannelDemographics.vue?vue&type=style&index=0&id=3a3d1ec2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports